import {ComputedRef, Ref, ref} from "@nuxtjs/composition-api";
import {useApi} from "~/composables";
import {Logger} from "~/helpers/logger";

const useOrderCancellation = (): UseOrderCancellation => {
  const loading = ref(false);

  const {
    mutate,
  } = useApi();

  const cancelOrder = async (id: string): Promise<CancelOrderResponse | null> => {
    const orderId = window.atob(id)
    const getMutationQuery = `
    mutation requestOrderCancellation ($orderId: Int) {
      requestOrderCancellation(input: {order_id: $orderId}) {
        message
        success
      }
    }`;
    let result: CancelOrderResponse | null = null;

    try {
      loading.value = true;
      const {data} = await mutate<CancelOrderResponse>(
        getMutationQuery,
        {
          // @ts-ignore
          "orderId": orderId
        }
      )
      result = data;
    } catch (error) {
      Logger.error('useOrderCancellation/cancelOrder', error);
    } finally {
      loading.value = false;
    }

    return result;
  }

  const cancelOrderItem = async (id: string): Promise<CancelOrderItemResponse | null> => {
    const orderItemId = window.atob(id)
    const getMutationQuery = `
    mutation requestOrderItemCancellation ($orderItemId: Int) {
      requestOrderItemCancellation(input: {order_item_id: $orderItemId}) {
        message
        success
      }
    }`;
    let result: CancelOrderItemResponse | null = null;

    try {
      loading.value = true;
      const {data} = await mutate<CancelOrderItemResponse>(
        getMutationQuery,
        {
          // @ts-ignore
          "orderItemId": orderItemId
        }
      )
      result = data;
    } catch (error) {
      Logger.error('useOrderCancellation/cancelOrderItem', error);
    } finally {
      loading.value = false;
    }

    return result;
  }

  return <UseOrderCancellation>{
    cancelOrder,
    cancelOrderItem
  }
}


interface UseOrderCancellation {
  cancelOrder(orderId): Promise<CancelOrderResponse | null>
  cancelOrderItem(orderItemId): Promise<CancelOrderItemResponse | null>
}

declare type CancelOrderResponse = {
  requestOrderCancellation: {
    success: boolean
    message: string
  }
}

declare type CancelOrderItemResponse = {
  requestOrderItemCancellation: {
    success: boolean
    message: string
  }
}

export default useOrderCancellation;
